import React from 'react'
import {
  Container,
  Stack,
  Row,
  Col,
} from 'react-bootstrap'
import { Link } from 'react-router-dom'

import CoinLogo from '../../assets/icons/coin-logo.svg'
import { SOCIAL_LINKS } from '../../constants'

import twitter from '../../assets/icons/socials/twitter.svg'
import youtube from '../../assets/icons/socials/youtube.svg'
import telegram from '../../assets/icons/socials/telegram.svg'
import linkedin from '../../assets/icons/socials/linkedin.svg'

export function Footer() {
  return (
    <footer id="staking-footer">
      <Container className={'footer-container'}>
        <Row className="footer-nav d-none d-md-flex">
          <div className="coinlogo staking-footer-title">
            <img className="campus-icon" alt="" src={CoinLogo} width={32} />
            Open Campus
          </div>
          <Col>
            <Row>
              <Col className={'footer-navigation d-flex flex-column'}>
                <h5
                  className={
                    'staking-footer-title staking-footer-font-Poppins'
                  }
                >
                  PRODUCTS
                </h5>
                <Link
                  className={'staking-footer-label'}
                  to="https://id.opencampus.xyz"
                >
                  OC ID
                </Link>
                <Link
                  className={'staking-footer-label'}
                  to="https://ocx.opencampus.xyz"
                >
                  OC-X
                </Link>
                <Link
                  className={'staking-footer-label'}
                  to="https://mint.opencampus.xyz"
                >
                  Publisher NFT
                </Link>
                <Link
                  className={'staking-footer-label'}
                  to="/oc-achievements"
                >
                  OC Achievements
                </Link>
              </Col>
              <Col className={'footer-navigation d-flex flex-column'}>
                <h5
                  className={
                    'staking-footer-title staking-footer-font-Poppins'
                  }
                >
                  EDU
                </h5>
                <Link
                  className={'staking-footer-label'}
                  to="/mica-whitepaper"
                  target='_blank'
                >
                  Whitepaper
                </Link>
                <Link
                  className={'staking-footer-label'}
                  to="https://coinmarketcap.com/currencies/open-campus/"
                >
                  CoinMarketCap
                </Link>
                <Link
                  className={'staking-footer-label'}
                  to="https://www.coingecko.com/en/coins/open-campus"
                >
                  CoinGecko
                </Link>
                <Link
                  className={'staking-footer-label'}
                  to="https://userdocs.opencampus.xyz"
                >
                  User Docs
                </Link>
              </Col>
              <Col className={'footer-navigation d-flex flex-column'}>
                <h5
                  className={
                    'staking-footer-title staking-footer-font-Poppins'
                  }
                >
                  ABOUT
                </h5>
                <Link
                  className={'staking-footer-label'}
                  to="/partners"
                >
                  OC Partners
                </Link>
                <Link
                  className={'staking-footer-label'}
                  to="https://100.opencampus.xyz"
                >
                  OC 100
                </Link>
                <Link
                  className={'staking-footer-label'}
                  to="https://drive.google.com/drive/folders/13JDKr5Z6wdjU5qJjJGG6PqQmeSnC1cTl?usp=sharing"
                  target='_blank'>
                  Media Kit
                </Link>
                {/* <Link
                  className={'staking-footer-label'}
                  to="https://legal.opencampus.xyz/tnc"
                >
                  Terms & Conditions
                </Link>
                <Link
                  className={'staking-footer-label'}
                  to="https://legal.opencampus.xyz/privacy"
                >
                  Privacy Notice
                </Link> */}
              </Col>
              <Col className={'footer-navigation d-flex flex-column'}>
                <h5
                  className={
                    'staking-footer-title staking-footer-font-Poppins'
                  }
                >
                  LEGAL
                </h5>
                <Link
                  className={'staking-footer-label'}
                  to="https://disclaimer.opencampus.xyz/main/"
                >
                  Terms of Use
                </Link>
              </Col>
            </Row>
          </Col>
        </Row>

        <div className={'staking-footer-divider d-none d-md-block'} />
        <div className="footer-items">
          <small>© 2024 Open Campus. All rights reserved.</small>
          <Stack
            className={'footer-items-socials'}
            direction="horizontal"
            gap={2}
          >
            <a href={SOCIAL_LINKS.twitter} target={'_blank'} rel="noreferrer">
              <img src={twitter} alt="twitter" />
            </a>
            <a href={SOCIAL_LINKS.youtube} target={'_blank'} rel="noreferrer">
              <img src={youtube} alt="youtube" />
            </a>
            <a href={SOCIAL_LINKS.telegram} target={'_blank'} rel="noreferrer">
              <img src={telegram} alt="telegram" />
            </a>
            <a href={SOCIAL_LINKS.linkedin} target={'_blank'}>
              <img src={linkedin} alt="linked in" />
            </a>
          </Stack>
          <div className="coinlogo staking-footer-title">
            <img className="campus-icon" alt="" src={CoinLogo} width={32} />
            Open Campus
          </div>
        </div>
      </Container>
    </footer>
  )
}